import { call, put, select, takeEvery, take, delay } from "redux-saga/effects";
import {
  bulkLoader,
  hidePlansListLoader,
  plansProfitLoader,
  setErrorPlanProfile,
  setFilteredDate,
  setPlanFilterData,
  setPlanProfile,
  setPlansList,
  setPlansProfit,
  setUsersList,
  showPlansListLoader,
  setPlanGroups,
  groupLoader,
  PayoutConditionLoader,
  setPayoutCondition,
  setTotalProfit,
  setCustomProfitByDays,
  loaderCustomProfitByDays,
  setDataByDays,
  setTotalPlan,
  setTopManagementReportsFilters,
  setProfitPlansWidgetData,
  setProfitPlansWidgetLoader,
  setProfitPlanOffers,
  setMarginPlan,
  setExecPlan,
  setMarginFilter,
  setLoadMarginFilter,
  setLoadCustomFilters,
  setCustomFilters,
  setLoaderManagementReportsFilters,
  setAggregatedOfferProfit,
  setLoaderAggregatedOfferProfit,
  setAggregatedManagersProfit,
  setLoaderAggregatedManagersProfit,
  setLoaderDataByDays,
  getPlansProfitStatus,
  getTopManagementReportsFilters,
  LoaderHRDetailedOffers,
  setHRDetailedOffers,
} from "./actions";
import {
  getErrorMessage,
  showErrorMessage,
  showInfoMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import {
  ADD_PLAN,
  ADD_PLAN_BULK,
  DELETE_PLAN,
  DELETE_PLAN_BULK,
  GET_PLANS_PROFIT,
  GET_PLAN_FILTER_DATA,
  GET_PLAN_LIST,
  GET_PLAN_PROFILE,
  UPDATE_PLAN_PROFILE,
  GET_PLAN_GROUPS,
  DELETE_PLAN_GROUP,
  ADD_PLAN_GROUP,
  UPDATE_PLAN_GROUP,
  GET_PAYOUT_CONDITIONS,
  UPDATE_PAYOUT_CONDITIONS,
  DELETE_PAYOUT_CONDITIONS,
  ADD_PAYOUT_CONDITIONS,
  ADD_NEW_ROW_OVERVIEW,
  REMOVE_NEW_ROW_OVERVIEW,
  ADD_CUSTOM_PROFIT,
  DELETE_CUSTOM_PROFIT,
  EDIT_CUSTOM_PROFIT,
  CLOSE_EDIT_CUSTOM_PROFIT,
  UPDATE_CUSTOM_PROFIT,
  GET_TOTAL_PROFIT_PLANS,
  GET_CUSTOM_PROFIT_BY_DAYS,
  PATCH_CUSTOM_PROFIT_BY_DAYS,
  ADD_CUSTOM_PROFIT_BY_DAYS,
  GET_TOTAL_PLAN,
  GET_TOP_MANAGEMENT_REPORTS_FILTERS,
  GET_PROFIT_PLANS_WIDGET,
  GET_PROFIT_PLAN_OFFERS,
  GET_PROFIT_PLAN_EXEC,
  GET_PROFIT_PLAN_MARGIN,
  GET_PROFIT_PLAN_CUSTOM_FILTER,
  GET_PROFIT_PLAN_MARGIN_FILTER,
  GET_AGGREGATED_OFFER_PROFIT,
  GET_AGGREGATED_MANAGERS_PROFIT,
  GET_DATA_BY_DAYS,
  GET_PLANS_HR_OFFER_DETAILED,
} from "./actionTypes";
import {
  deletePlan,
  deletePlanBulk,
  deletePlansGroups,
  getPlan,
  getPlanFilterData,
  getPlanProfitData,
  getPlans,
  getPlansGroups,
  getUsersList,
  patchPlan,
  postPlan,
  postPlanBulk,
  postPlansGroups,
  updatePlansGroup,
  getPayoutConditions,
  postPayoutCondition,
  patchPayoutCondition,
  deletePayoutCondition,
  patchPlansBulk,
  postCustomProfit,
  deleteCustomProfit,
  patchCustomProfit,
  postCustomProfitCashback,
  patchCustomProfitCashback,
  getTotalProfitPlanData,
  getCustomProfitByDayBulk,
  postCustomProfitByDayBulk,
  getProfitByDays,
  getCostByDays,
  getMarginByDays,
  patchCustomProfitByDayBulk,
  deleteCustomProfitByDayBulk,
  postManagerCashbackBulk,
  deleteManagerCashbackBulk,
  patchManagerCashbackBulk,
  getTotalPlanData,
  getMetaAdPlatforms,
  getOffersList,
  getPlansProfitWidgets,
  getProfitPlanOfferData,
  getProfitPlanMarginData,
  getProfitPlanExecutionData,
  getProfitExecFiltersData,
  getProfitMarginFiltersData,
  getAggregatedManagersProfitData,
  getAggregatedOfferProfitData,
  getOffersByBuyersList,
  getCampaignSources,
  getManagersPlansWithStats,
  getOffersPlansWithStats,
  getPlansHROfferDetailed,
} from "../../helpers/jwt_helper";

function* onGetPlanDateFilters() {
  try {
    let response = yield call(getPlanFilterData);
    let users = yield call(getUsersList, { size: 0, is_active: true });
    let filteredUsers = [];

    users.map(i => {
      if (i.positions_list !== 'Admin' && i.positions_list !== 'CEO') {
        filteredUsers.push({
          value: i.id,
          label: `${i.first_name} ${i.last_name}`,
        })
      }
    })

    response = {
      offers_with_id: response.offers.map(i => ({
        value: i.id,
        label: i.name,
      })),
      offers: response.offers.map(i => ({ value: i.name, label: i.name })),
      account_managers: response.account_managers.map(i => ({
        value: i.id,
        label: i.full_name,
      })),
      all_account_managers: response.all_account_managers.map(i => ({
        value: i.id,
        label: i.full_name,
      })),
      all_offers: response.all_offers.map(i => ({
        value: i.id,
        label: i.name,
      })),
      users: filteredUsers,
    };

    yield put(setPlanFilterData(response));
  } catch (error) { }
}

function* onGetPlanList({ payload: data }) {
  try {
    yield put(showPlansListLoader());
    let newData = {
      ...(yield select(state => state.PlanList.data)),
      ...data,
    };

    let params = {
      page: newData.page,
      size: data.sizePerPage,
      ordering: newData.ordering,
      search: newData.search,
      date_from_gte: newData?.start_date,
      date_to_lte: newData?.end_date,
    };

    if (newData?.group) params.group = newData.group;
    if (newData?.offer_id) params.offer = newData.offer_id;
    if (newData?.offer?.length > 0) params.offer = newData.offer;
    if (newData?.account_manager?.length > 0)
      params.account_manager = newData.account_manager;

    let response = yield call(getPlans, params);
    response = {
      ...newData,
      ...response,
      results: response.results.map(i => ({
        ...i,
        description: i.description === "string" ? "" : i.description,
      })),
    };
    let users = yield call(getUsersList, { size: 0 });
    users = {
      users: users.map(i => ({ value: i.id, label: i.username })),
    };
    yield put(setUsersList(users));
    yield put(setPlansList(response));
    yield delay(10);
    yield put(hidePlansListLoader());
  } catch (error) {
    yield put(hidePlansListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddPlan({ payload: data }) {
  try {
    let currentData = yield select(state => state.PlanList.data);
    yield call(postPlan, data);
    yield call(onGetPlanList, {
      payload: currentData,
    });
    showSuccessMessage("Plan has been added");
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeletePlan({ payload: { id } }) {
  try {
    let currentData = yield select(state => state.PlanList.data);
    yield put(showPlansListLoader());
    yield call(deletePlan, id);
    yield call(onGetPlanList, { payload: currentData });
    yield put(hidePlansListLoader());
    showSuccessMessage("Plan has been deleted");
  } catch (error) {
    yield put(hidePlansListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetPlanProfile({ payload: id }) {
  try {
    yield put(setErrorPlanProfile(false));
    let response = yield call(getPlan, id); // get plan profile
    yield put(setPlanProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorPlanProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdatePlanProfile({ payload: { id, params } }) {
  try {
    let currentData = yield select(state => state.PlanList.data);
    yield put(showPlansListLoader());
    yield call(patchPlan, id, params);
    yield call(onGetPlanList, { payload: currentData });
    yield put(hidePlansListLoader());
    showSuccessMessage("Plan has been updated");
  } catch (error) {
    yield put(hidePlansListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetPlansProfit({ payload: params }) {
  try {
    yield put(
      setFilteredDate({
        start_date: params.date_from,
        end_date: params.date_to,
        ...(params?.ordering && { ordering: params.ordering })
      })
    );
    yield put(plansProfitLoader());
    let response = yield call(getPlanProfitData, params);
    yield put(
      setPlansProfit({
        widget: response?.widget || {},
        results: typeof response?.data == 'string' ? [] : response?.data || [],
      })
    );

    if (response?.data && typeof response?.data != 'string') {
      yield put(getPlansProfitStatus(206));
    } else {
      yield put(getPlansProfitStatus(null));
    }
    yield put(plansProfitLoader());
  } catch (error) {
    yield put(plansProfitLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddPlanBulk({ payload: { data, history } }) {
  try {
    yield put(bulkLoader());
    let currentGroupsData = [];
    let date = {
      ...(yield select(state => state.PlanList.profitFilterData)),
    };

    let currentData = yield select(state => state.PlanList.data);

    let response = yield call(
      postPlansGroups,
      data.map(i => {
        return {
          name: i.group,
          date_from: data[0].date_from,
          date_to: data[0].date_to,
        };
      })
    );

    data.map((i, idx) => {
      if (i.group === response[idx].name) {
        i.offer.map(o => {
          currentGroupsData.push({
            account_manager: i.account_manager,
            group: response[idx].id,
            offer: o.value,
            plan: (i.plan / i.offer.length).toFixed(2),
            corrected_plan: (i.corrected_plan / i.offer.length).toFixed(2),
          });
        });
      }
    });

    yield call(postPlanBulk, currentGroupsData);

    yield call(onGetPlanList, {
      payload: currentData,
    });

    showSuccessMessage("Plans has been added successfully");
    yield put(bulkLoader());
    history.push(
      `/project-manager-plans?start_date=${date.start_date}&end_date=${date.end_date}#plans`
    );
  } catch (error) {
    if (Array.isArray(error.response.data)) {
      error.response.data.map(i => {
        for (let [key, value] of Object.entries(i)) {
          showErrorMessage(
            getErrorMessage(
              `${key}: ${Array.isArray(value) ? value[0] : value}`
            )
          );
        }
      });
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(bulkLoader());
  }
}

function* onDeletePlanBulk({ payload: data }) {
  try {
    let params = {
      ids: data.join(","),
    };
    yield put(showPlansListLoader());
    let currentData = yield select(state => state.PlanList.data);
    yield call(deletePlanBulk, params);
    yield call(onGetPlanList, {
      payload: currentData,
    });
    showSuccessMessage("Plans has been deleted successfully");
    yield put(hidePlansListLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(hidePlansListLoader());
  }
}

function* onGetPlanGroups({ payload: data }) {
  try {
    yield put(groupLoader());
    let params = {
      ...data,
      page: data?.page,
      size: data?.size,
      ordering: data?.ordering,
      search: data?.search,
      results: [],
    };

    let response = yield call(getPlansGroups, params);

    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };
    yield put(setPlanGroups(response));
    yield put(groupLoader());
  } catch (error) {
    yield put(groupLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeletePlanGroupsBulk({ payload: data }) {
  try {
    let params = {
      ids: data.join(","),
    };
    yield put(groupLoader());
    let currentData = yield select(state => state.PlanList.data);
    yield call(deletePlansGroups, params);
    yield call(onGetPlanGroups, {
      payload: currentData,
    });
    showSuccessMessage(
      ` ${data.length === 1 ? "Plan" : "Plans"
      } Plans has been deleted successfully`
    );
    yield put(groupLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(groupLoader());
  }
}

function* onAddPlanGroup({ payload: data }) {
  try {
    yield put(groupLoader());
    let currentData = yield select(state => state.PlanList.groups);
    yield call(postPlansGroups, data);
    yield call(onGetPlanGroups, {
      payload: currentData,
    });
    showSuccessMessage("Group has been added successfully");
    yield put(groupLoader());
  } catch (error) {
    if (Array.isArray(error.response.data)) {
      error.response.data.map(i => {
        for (let [key, value] of Object.entries(i)) {
          showErrorMessage(
            getErrorMessage(
              `${key}: ${Array.isArray(value) ? value[0] : value}`
            )
          );
        }
      });
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(groupLoader());
  }
}

function* onUpdatePlanGroup({ payload: { id, data } }) {
  try {
    let filterData = yield select(state => state.PlanList.profitFilterData);
    let currentData = yield select(state => state.PlanList.groups);
    let currentGroupName = currentData.results.find(i => i.name === data.name);
    let updateGroupPlan = [];
    let perms = yield select(state => state.User.permissions);
    
    yield put(groupLoader());
    let plansGroup = yield call(getPlans, {
      group: id,
      size: 0,
      results: [],
    });
    plansGroup.map(i => {
      updateGroupPlan.push({
        id: i.id,
        plan: (data.planned_sum / plansGroup.length).toFixed(2),
        corrected_plan: (data.corrected_plan / plansGroup.length).toFixed(2),
      });
    });

    if (data?.cashback_type) {
      try {
        if (data?.cashback_id == null) {
          yield call(postCustomProfitCashback, {
            cashback: data?.cashback,
            plan_id: data?.id,
            plan_type: data?.cashback_type,
          });
        } else {
          yield call(patchCustomProfitCashback, data.cashback_id, {
            cashback: data?.cashback,
            plan_type: data?.cashback_type,
          });
        }
      } catch (err) {
        // console.log(data?.cashback_id);
      }
    }

    yield call(patchPlansBulk, updateGroupPlan);
    if (currentGroupName === undefined)
      yield call(updatePlansGroup, id, {
        name: data.name,
      });
    yield call(onGetPlanGroups, {
      payload: currentData,
    });
    yield call(onGetPlansProfit, {
      payload: {
        date_from: filterData.start_date,
        date_to: filterData.end_date,
        ...(!perms['is_admin'] && perms['is_accountmanager'] && { for_yourself: true }) 
      },
    });
    yield put(groupLoader());
    showSuccessMessage("Group has been updated");
  } catch (error) {
    yield put(groupLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetPayoutConditions({ payload: data }) {
  try {
    yield put(PayoutConditionLoader());
    let response = yield call(getPayoutConditions, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };
    yield put(setPayoutCondition(response));
    yield put(PayoutConditionLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(PayoutConditionLoader());
  }
}

function* onUpdatePayoutCondition({ payload: data }) {
  try {
    let currentData = yield select(state => state.PlanList.payoutData);
    yield put(PayoutConditionLoader());
    yield call(patchPayoutCondition, data);
    yield call(onGetPayoutConditions, {
      payload: currentData,
    });
    yield put(PayoutConditionLoader());
    showSuccessMessage("Payout condition has been updated");
  } catch (error) {
    yield put(PayoutConditionLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddPayoutCondition({ payload: data }) {
  try {
    yield put(PayoutConditionLoader());
    let currentData = yield select(state => state.PlanList.payoutData);
    yield call(postPayoutCondition, data);
    yield call(onGetPayoutConditions, {
      payload: currentData,
    });
    showSuccessMessage("Payout condition has been added successfully");
    yield put(PayoutConditionLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(PayoutConditionLoader());
  }
}

function* onDeletePayoutConditions({ payload: data }) {
  try {
    let params = {
      ids: data.join(","),
    };
    yield put(PayoutConditionLoader());
    let currentData = yield select(state => state.PlanList.payoutData);
    yield call(deletePayoutCondition, params);
    yield call(onGetPayoutConditions, {
      payload: currentData,
    });
    showSuccessMessage(
      `Payout${data.length === 1 ? "condition" : "conditions"
      } has been deleted successfully`
    );
    yield put(PayoutConditionLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(PayoutConditionLoader());
  }
}

function* onAddNewRowOverview({ payload: { idx, newRow } }) {
  try {
    let currentData = yield select(state => state.PlanList.profit_plans);
    let updatedData = {
      results: currentData.results.splice(idx + 1, 0, newRow),
    };
    yield put(
      setPlansProfit({
        results: currentData.results,
      })
    );
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onRemoveNewRowOverview({ payload: idx }) {
  try {
    let currentData = yield select(state => state.PlanList.profit_plans);
    let updatedData = {
      results: currentData.results.splice(idx, 1),
    };
    yield put(
      setPlansProfit({
        results: currentData.results,
      })
    );
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCustomProfit({ payload: { idx, data } }) {
  try {
    let params = {
      ...data[0],
    };

    let currentData = yield select(state => state.PlanList.profit_plans);
    let perms = yield select(state => state.User.permissions);
    const customFiled = yield call(postCustomProfit, params);

    try {
      if (params?.cashback) {
        yield call(postCustomProfitCashback, {
          cashback: params?.cashback,
          plan_id: customFiled?.id,
          plan_type: "custom",
        });
      }
    } catch (err) {
      if (typeof err.response.data === "object") {
        for (let [key, value] of Object.entries(err.response.data)) {
          showErrorMessage(getErrorMessage(`${key}: ${value}`));
        }
      } else {
        showErrorMessage(getErrorMessage(err));
      }

      yield call(onGetPlanList, {
        payload: currentData,
      });
    }

    yield call(onGetPlanList, {
      payload: currentData,
    });

    let updatedData = {
      results: currentData.results.splice(idx, 1),
    };

    yield call(onGetPlansProfit, {
      payload: {
        date_from: params.date_from,
        date_to: params.date_to,
        ...(!perms['is_admin'] && perms['is_accountmanager'] && { for_yourself: true })
      },
    });
    showSuccessMessage("Custom profit has been added");
  } catch (error) {
    if (typeof error.response.data === "object") {
      for (let [key, value] of Object.entries(error.response.data)) {
        showErrorMessage(getErrorMessage(`${key}: ${value}`));
      }
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onDeleteCustomProfit({ payload: id }) {
  try {
    let filterData = yield select(state => state.PlanList.profitFilterData);
    let perms = yield select(state => state.User.permissions);
    
    yield call(deleteCustomProfit, id);
    let res = yield call(onGetPlansProfit, {
      payload: {
        date_from: filterData.start_date,
        date_to: filterData.end_date,
        ...(!perms['is_admin'] && perms['is_accountmanager'] && { for_yourself: true })
      },
    });
    showSuccessMessage(`Custom profit has been deleted successfully`);
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onEditCustomProfit({ payload: index }) {
  try {
    let currentData = yield select(state => state.PlanList.profit_plans);
    let object = currentData.results[index];
    Object.assign(object, {
      ...object,
      can_edit: true,
    });
    currentData[index] = object;
    yield put(
      setPlansProfit({
        results: [...currentData.results],
      })
    );
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onCloseEditCustomProfit({ payload: index }) {
  try {
    let currentData = yield select(state => state.PlanList.profit_plans);
    let object = currentData.results[index];
    delete object["can_edit"];
    currentData[index] = object;
    yield put(
      setPlansProfit({
        results: [...currentData.results],
      })
    );
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateCustomProfit({ payload: data }) {
  try {
    let params = data;
    let cashbackData = {
      cashback: params?.cashback,
      plan_type: params?.cashback_type,
    };
    delete params["cashback_type"];
    let filterData = yield select(state => state.PlanList.profitFilterData);
    let perms = yield select(state => state.User.permissions);

    yield call(patchCustomProfit, params.id, params);

    if (cashbackData?.cashback) {
      if (data?.cashback_id == null) {
        yield call(postCustomProfitCashback, {
          cashback: data?.cashback,
          plan_id: data?.id,
          plan_type: "custom",
        });
      } else {
        yield call(patchCustomProfitCashback, data.cashback_id, {
          cashback: cashbackData?.cashback,
          plan_type: cashbackData?.cashback_type,
        });
      }
    }

    yield call(onGetPlansProfit, {
      payload: {
        date_from: filterData.start_date,
        date_to: filterData.end_date,
        ...(!perms['is_admin'] && perms['is_accountmanager'] && { for_yourself: true })
      },
    });
    showSuccessMessage("Custom profit has been updated");
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTotalProfitPlans({ payload: data }) {
  try {
    // yield put(loaderCustomProfitByDays());
    let response = yield call(getTotalProfitPlanData, {
      date_from: data.date_from,
      date_to: data.date_to,
    });
    yield put(setTotalProfit(response));
    // yield put(loaderCustomProfitByDays());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    // yield put(loaderCustomProfitByDays());
  }
}

function* onGetTotalPlan({ payload: data }) {
  try {
    // yield put(loaderCustomProfitByDays());
    let response = yield call(getTotalPlanData, {
      date_from: data.date_from,
      date_to: data.date_to,
      account_manager: data.account_manager,
      ...(data?.buyers && { buyers: data.buyers })
    });
    yield put(setTotalPlan(response));
    // yield put(loaderCustomProfitByDays());
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(loaderCustomProfitByDays());
  }
}

function* onGetCustomProfitByDays({ payload: data }) {
  try {
    // yield put(loaderCustomProfitByDays());
    let params = {
      date_gte: data.date_from,
      date_lte: data.date_to,
      size: 0,
    };

    if (data?.main) params.main = data.main;

    let response = yield call(getCustomProfitByDayBulk, {
      ...params,
    });
    yield put(setCustomProfitByDays(response));
    // yield put(loaderCustomProfitByDays());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCustomProfitByDay({ payload: data }) {
  try {
    yield put(loaderCustomProfitByDays());
    let { cashback, plan } = data;
    let cashbackData = [];
    let res = yield call(postCustomProfitByDayBulk, plan);

    res.map((i, k) => {
      cashbackData.push({
        ...cashback[k],
        plan_id: i.id,
      });
    });

    if (cashback.length > 0) yield call(postManagerCashbackBulk, cashbackData);

    yield put(loaderCustomProfitByDays());
  } catch (error) {
    yield put(loaderCustomProfitByDays());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchCustomProfitByDays({ payload: data }) {
  try {
    yield put(loaderCustomProfitByDays());

    const { drop, add, patch, cashback } = data;

    if (drop?.length > 0) {
      yield call(deleteCustomProfitByDayBulk, drop.join(","));
      yield call(deleteManagerCashbackBulk, cashback.drop.join(","));
    }

    if (add?.length > 0) {
      let cashbackData = [];
      let res = yield call(postCustomProfitByDayBulk, data.add);
      res.map((i, k) => {
        cashbackData.push({
          ...cashback.add[k],
          plan_id: i.id,
        });
      });
      yield call(postManagerCashbackBulk, cashbackData);
    }

    if (patch?.length > 0) {
      yield call(patchCustomProfitByDayBulk, patch);
      yield call(patchManagerCashbackBulk, cashback.patch);
    }

    yield put(loaderCustomProfitByDays());
  } catch (error) {
    yield put(loaderCustomProfitByDays());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetDataByDays({ payload: { data, type, paramsForFilters } }) {
  try {
    yield put(setLoaderDataByDays());
    if (paramsForFilters?.date_from) {
      yield call(onGetTopManagementReportsFilters, { payload: paramsForFilters });
      let offers_in_filter = yield select(state => state.PlanList.topReportsFilters.offers);
      let params = {
        ...data,
        offer: offers_in_filter.map(offer => offer.id).join(','),
        size: 0,
        summarize: true,
      };
      let res = [];

      switch (type) {
        case "profit":
          res = yield call(getProfitByDays, {
            ...params,
          });
          break;
        case "cost":
          res = yield call(getCostByDays, {
            ...params,
          });
          break;
        case "margin":
          res = yield call(getMarginByDays, {
            ...params,
          });
          break;
      }

      yield put(setDataByDays(res));
      yield put(setLoaderDataByDays());
    } else {
      let params = {
        ...data,
        size: 0,
        summarize: true,
      };
      let res = [];

      switch (type) {
        case "profit":
          res = yield call(getProfitByDays, {
            ...params,
          });
          break;
        case "cost":
          res = yield call(getCostByDays, {
            ...params,
          });
          break;
        case "margin":
          res = yield call(getMarginByDays, {
            ...params,
          });
          break;
      }

      yield put(setDataByDays(res));
      yield put(setLoaderDataByDays());

    }

  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(setLoaderDataByDays());
  }
}

function* onGetTopManagementReportsFilters({ payload: params }) {
  try {
    yield put(setLoaderManagementReportsFilters());
    yield put(setTopManagementReportsFilters({
      ...(yield select(state => state.PlanList.topReportsFilters)),
      managers: [],
      offers: [],
    }))

    const moWithStats = yield call(getManagersPlansWithStats, {
      date_from: params.date_from,
      date_to: params.date_to
    });

    const offersWithStats = yield call(getOffersPlansWithStats, {
      ...(params?.account_manager && {
        manager: params.account_manager,
      }),
      ...(params?.media_buyer && { media_buyers: params.media_buyer }),
      date_from: params.date_from,
      date_to: params.date_to
    });

    let adPlatforms = [];

    try {
      adPlatforms = yield call(getCampaignSources, {
        size: 0,
      });
    } catch (e) {
      console.log(e);
    }

    let managers = yield call(getUsersList, {
      size: 0,
      positions__title: "Project Manager",
    });

    let res = {
      offers: offersWithStats.offers.map(i => ({
        id: i.main_parent_id, //i.offer_id,
        name: i.offer_name,
        checked: true,
      })),
      platforms: adPlatforms.map(i => ({
        id: i.name,
        name: i.name,
        checked: true,
      })),
      managers: moWithStats.account_managers.map(i => ({
        id: i.id,
        name: `${i.first_name} ${i.last_name}`,
        checked: true,
      })),
      managers_more: managers.map(i => ({
        id: i.id,
        name: `${i.first_name} ${i.last_name}`,
        positions: i.positions,
        email: i.email,
        username: i.username,
      })),
      buyers: moWithStats.media_buyers.map(i => ({
        id: i.id,
        name: `${i.first_name} ${i.last_name}`,
        checked: true,
      })),
    };
    yield put(setTopManagementReportsFilters(res));
    yield put(setLoaderManagementReportsFilters());
    // console.log(res)
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    console.log(error)
    yield put(setLoaderManagementReportsFilters());
  }
}

function* onGetProfitPlansWidget({ payload: data }) {
  try {
    yield put(setProfitPlansWidgetLoader());
    let widgetData = [
      ...(yield select(state => state.PlanList.topReportsWidgets)),
    ];
    let response = yield call(getPlansProfitWidgets, {
      ...data,
    });
    Object.keys(response).forEach((key, idx) => {
      widgetData[idx].value = response[key] || 0;
    });
    yield put(setProfitPlansWidgetData(widgetData));
    yield put(setProfitPlansWidgetLoader());
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(setProfitPlansWidgetLoader());
  }
}

function* onGetProfitPlanOffers({ payload: { data, buyer } }) {
  try {
    let categories = [];

    if (buyer) {
      categories = ["Plan", "Profit", "Cost"];
    } else {
      categories = [
        "Plan",
        "Profit",
        "Cost",
        "Paid Invoice",
        "Overdue Invoice",
      ];
    }

    let dt = {
      options: {
        xaxis: {
          categories,
        },
      },
      data: [],
    };

    let response = yield call(getProfitPlanOfferData, {
      ...data,
    });
    for (let [key, val] of Object.entries(response)) {
      if (
        buyer &&
        key !== "total_not_paid_invoices" &&
        key !== "total_paid_invoices"
      ) {
        dt.data.push(val || 0);
      } else if (!buyer) {
        dt.data.push(val || 0);
      }
    }
    yield put(setProfitPlanOffers(dt));
  } catch (error) {
    showInfoMessage(getErrorMessage(`Data is empty for the plans at now`));
  }
}

function* onGetPlanExecution({ payload: data }) {
  try {
    let dt = {
      options: {
        xaxis: {
          labels: {
            formatter: function (value) {
              return value + "%";
            },
          },
          categories: [],
        },
      },
      data: [],
    };

    let response = yield call(getProfitPlanExecutionData, {
      ...data,
    });

    if (response.length > 0) {
      response.map(i => {
        dt.options.xaxis.categories.push(i.key || "N/A");
        dt.data.push(parseFloat(i.value).toFixed(2) || 0);
      });
    }

    yield put(setExecPlan(dt));
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
  }
}

function* onGetPlanMargin({ payload: data }) {
  try {
    let dt = {
      options: {
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      data: [],
    };
    let response = yield call(getProfitPlanMarginData, {
      ...data,
    });
    if (response.length > 0) {
      response.map(i => {
        dt.options.xaxis.categories.push(i.key || "N/A");
        dt.data.push(parseFloat(i.value).toFixed(2) || 0);
      });
    }
    yield put(setMarginPlan(dt));
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCustomFilters({ payload: params }) {
  try {
    const { buyer } = params;
    yield put(setLoadCustomFilters());
    let resExecFilters = yield call(getProfitExecFiltersData);
    let resMarginFilters = yield call(getProfitMarginFiltersData);
    let users = yield call(getUsersList, { size: 0, is_active: true });
    let filteredUsers = [];

    users.map(i => {
      if (i.positions_list !== 'Admin' && i.positions_list !== 'CEO') {
        filteredUsers.push({
          id: i.id,
          name: `${i.first_name} ${i.last_name}`,
          checked: true,
        })
      }
    })
    let filters = {
      marginFilters: [],
      execFilters: [],
      users: filteredUsers,
    };

    if (Object.entries(resExecFilters)?.length > 0) {
      for (let [key, val] of Object.entries(resExecFilters)) {
        if (buyer && val === "group_name") {
          filters.execFilters.push({
            label: key == 'Manager' ? "Project Manager" : key,
            value: val,
          });
        } else if (!buyer) {
          filters.execFilters.push({
            label: key == 'Manager' ? "Project Manager" : key,
            value: val,
          });
        }
      }
    }

    if (Object.entries(resMarginFilters)?.length > 0) {
      for (let [key, val] of Object.entries(resMarginFilters)) {
        if ((buyer && val === "offer_name") || val === "media_source") {
          filters.marginFilters.push({
            label: key == 'Manager' ? "Project Manager" : key,
            value: val,
          });
        } else if (!buyer) {
          filters.marginFilters.push({
            label: key == 'Manager' ? "Project Manager" : key,
            value: val,
          });
        }
      }
    }

    yield put(setCustomFilters(filters));
    yield put(setLoadCustomFilters());
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(setLoadCustomFilters());
  }
}

function* onGetMarginFilters({ payload: params }) {
  try {
    yield put(setLoadMarginFilter());
    let res = yield call(getProfitMarginFiltersData);
    let filters = [];

    if (Object.entries(res)?.length > 0) {
      for (let [key, val] of Object.entries(res)) {
        filters.push({
          label: key,
          value: val,
        });
      }
    }
    yield put(setMarginFilter(filters));
    yield put(setLoadMarginFilter());
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(setLoadMarginFilter());
  }
}

function* onGetAggregatedOffer({ payload: params }) {
  try {
    setLoaderAggregatedOfferProfit;
    yield put(setLoaderAggregatedOfferProfit());
    let res = yield call(getAggregatedOfferProfitData, params);
    yield put(setAggregatedOfferProfit(res));
    yield put(setLoaderAggregatedOfferProfit());
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(setLoaderAggregatedOfferProfit());
  }
}

function* onGetAggregatedManagers({ payload: params }) {
  try {
    yield put(setLoaderAggregatedManagersProfit());
    let res = yield call(getAggregatedManagersProfitData, params);
    yield put(setAggregatedManagersProfit(res));
    yield put(setLoaderAggregatedManagersProfit());
  } catch (error) {
    // showErrorMessage(getErrorMessage(error));
    yield put(setLoaderAggregatedManagersProfit());
  }
}

function* onGetHROfferDetailed({ payload: params }) {
  try {
    yield put(LoaderHRDetailedOffers());

    let data = {
      data: [],
      head: ["Offer", "Manager", "Sales",
        "Buyers", "Plan", "Profit", "Cashback",
        "Profit With Cashback", "Margin", "Percent"],
      total: {}
    }

    let res = yield call(getPlansHROfferDetailed, params);

    if (res.length > 0) {
      res.map((i, k) => {
        if (i?.offer_name !== 'Total') {
          const { offer_name, manager, sales_manager,
            buyers, plan, profit, cashback, profit_with_cashback,
            margin, percent } = i;
          const updatedObject = {
            offer_name, manager, sales_manager,
            buyers, plan, profit, cashback, profit_with_cashback,
            margin, percent
          };
          data.data.push(updatedObject)
        } else {
          data.total['plan'] = i.plan
          data.total['profit'] = i.profit
          data.total['cashback'] = i.cashback
          data.total['profit_with_cashback'] = i.profit_with_cashback
          data.total['margin'] = i.margin
          data.total['percent'] = i.percent
        }

      })
    }
    yield put(setHRDetailedOffers(data));
    yield put(LoaderHRDetailedOffers());
  } catch (error) {
    console.log(error)
    // showErrorMessage(getErrorMessage(error));
    yield put(LoaderHRDetailedOffers());
  }
}

function* planListSaga() {
  yield takeEvery(GET_PLAN_LIST, onGetPlanList);
  yield takeEvery(DELETE_PLAN, onDeletePlan);
  yield takeEvery(ADD_PLAN, onAddPlan);
  yield takeEvery(GET_PLAN_PROFILE, onGetPlanProfile);
  yield takeEvery(UPDATE_PLAN_PROFILE, onUpdatePlanProfile);
  yield takeEvery(GET_PLAN_FILTER_DATA, onGetPlanDateFilters);
  yield takeEvery(GET_PLANS_PROFIT, onGetPlansProfit);
  yield takeEvery(ADD_PLAN_BULK, onAddPlanBulk);
  yield takeEvery(DELETE_PLAN_BULK, onDeletePlanBulk);
  yield takeEvery(GET_PLAN_GROUPS, onGetPlanGroups);
  yield takeEvery(DELETE_PLAN_GROUP, onDeletePlanGroupsBulk);
  yield takeEvery(ADD_PLAN_GROUP, onAddPlanGroup);
  yield takeEvery(UPDATE_PLAN_GROUP, onUpdatePlanGroup);
  yield takeEvery(GET_PAYOUT_CONDITIONS, onGetPayoutConditions);
  yield takeEvery(UPDATE_PAYOUT_CONDITIONS, onUpdatePayoutCondition);
  yield takeEvery(ADD_PAYOUT_CONDITIONS, onAddPayoutCondition);
  yield takeEvery(DELETE_PAYOUT_CONDITIONS, onDeletePayoutConditions);
  yield takeEvery(ADD_NEW_ROW_OVERVIEW, onAddNewRowOverview);
  yield takeEvery(REMOVE_NEW_ROW_OVERVIEW, onRemoveNewRowOverview);
  yield takeEvery(ADD_CUSTOM_PROFIT, onAddCustomProfit);
  yield takeEvery(DELETE_CUSTOM_PROFIT, onDeleteCustomProfit);
  yield takeEvery(EDIT_CUSTOM_PROFIT, onEditCustomProfit);
  yield takeEvery(CLOSE_EDIT_CUSTOM_PROFIT, onCloseEditCustomProfit);
  yield takeEvery(UPDATE_CUSTOM_PROFIT, onUpdateCustomProfit);
  yield takeEvery(GET_TOTAL_PROFIT_PLANS, onGetTotalProfitPlans);
  yield takeEvery(GET_TOTAL_PLAN, onGetTotalPlan);
  yield takeEvery(GET_CUSTOM_PROFIT_BY_DAYS, onGetCustomProfitByDays);
  yield takeEvery(ADD_CUSTOM_PROFIT_BY_DAYS, onAddCustomProfitByDay);
  yield takeEvery(PATCH_CUSTOM_PROFIT_BY_DAYS, onPatchCustomProfitByDays);
  yield takeEvery(GET_DATA_BY_DAYS, onGetDataByDays);
  yield takeEvery(GET_PROFIT_PLAN_OFFERS, onGetProfitPlanOffers);
  yield takeEvery(
    GET_TOP_MANAGEMENT_REPORTS_FILTERS,
    onGetTopManagementReportsFilters
  );
  yield takeEvery(GET_PROFIT_PLANS_WIDGET, onGetProfitPlansWidget);
  yield takeEvery(GET_PROFIT_PLAN_EXEC, onGetPlanExecution);
  yield takeEvery(GET_PROFIT_PLAN_MARGIN, onGetPlanMargin);
  yield takeEvery(GET_PROFIT_PLAN_CUSTOM_FILTER, onGetCustomFilters);
  yield takeEvery(GET_PROFIT_PLAN_MARGIN_FILTER, onGetMarginFilters);
  yield takeEvery(GET_AGGREGATED_MANAGERS_PROFIT, onGetAggregatedManagers);
  yield takeEvery(GET_AGGREGATED_OFFER_PROFIT, onGetAggregatedOffer);
  yield takeEvery(GET_PLANS_HR_OFFER_DETAILED, onGetHROfferDetailed)
}

export default planListSaga;